import { render, staticRenderFns } from "./PlateBoundaries.vue?vue&type=template&id=202615e4&"
import script from "./PlateBoundaries.vue?vue&type=script&lang=js&"
export * from "./PlateBoundaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports